export enum JkFormBuilderAction {
  INIT,
  EDIT_INPUT,
  UPDATE_INPUT,
  INPUT_TYPE_CHANGE,
  EDIT_FORM,
  APPLY_FORM_ACTION
}

